import ArticleCardCarousel, {
  Referer,
} from "@components/Carousel/ArticleCardCarousel";
import AdsContainer from "@components/Container/AdsContainer";
import { LabelCardIconVariety } from "@components/Icon/LabelCardIcon";
import ArticleElementWrapper from "@pages/Article/Components/ArticleElementWrapper";
import { ProcessedArticleData } from "@transformer/useOSResponse";
import React from "react";

import HardRegBanner from "../HardRegBanner";
import RegistrationBanner from "../RegistrationBanner";
import SubscriptionBanner from "../SubscriptionBanner";

type InsertionProps = {
  paragraphCount: number;
  newDesign?: boolean;
  adsImu1: React.ReactNode;
  adsMidArticle: React.ReactNode;
  pageNumber: number;
  isInfiniteScrollArticle: boolean;
  latestRegisteredArticle: ProcessedArticleData[];
  contentAccess: LabelCardIconVariety;
  showSubBanner: boolean;
  showGenGSubBanner: boolean;
  showRegBanner: boolean;
  showReg2Banner: boolean;
};

export function getAdAndBannerInsertions({
  paragraphCount,
  newDesign = false,
  adsImu1,
  adsMidArticle,
  pageNumber,
  isInfiniteScrollArticle,
  latestRegisteredArticle,
  contentAccess,
  showSubBanner,
  showGenGSubBanner,
  showRegBanner,
  showReg2Banner,
}: InsertionProps): React.ReactNode {
  switch (paragraphCount) {
    case 0:
      return (
        <>
          {showGenGSubBanner && (
            <>
              <ArticleElementWrapper>
                <SubscriptionBanner
                  isInfiniteScrollArticle={isInfiniteScrollArticle}
                  pageNumber={pageNumber}
                  isGenG
                />
              </ArticleElementWrapper>
              {newDesign ? (
                <AdsContainer className="my-6 lg:my-8">{adsImu1}</AdsContainer>
              ) : (
                <>{adsImu1}</>
              )}
            </>
          )}
        </>
      );

    case 1:
      return (
        <>
          {showSubBanner && (
            <>
              <ArticleElementWrapper>
                <SubscriptionBanner
                  isInfiniteScrollArticle={isInfiniteScrollArticle}
                  pageNumber={pageNumber}
                />
              </ArticleElementWrapper>
              {newDesign ? (
                <AdsContainer className="my-6 lg:my-8">{adsImu1}</AdsContainer>
              ) : (
                <>{adsImu1}</>
              )}
            </>
          )}
          {showRegBanner && (
            <>
              <ArticleElementWrapper>
                <RegistrationBanner
                  isInfiniteScrollArticle={isInfiniteScrollArticle}
                  pageNumber={pageNumber}
                />
              </ArticleElementWrapper>
              {newDesign ? (
                <AdsContainer className="my-6 lg:my-8">{adsImu1}</AdsContainer>
              ) : (
                <>{adsImu1}</>
              )}
            </>
          )}
          {showReg2Banner && (
            <>
              <ArticleElementWrapper>
                <HardRegBanner
                  isInfiniteScrollArticle={isInfiniteScrollArticle}
                  pageNumber={pageNumber}
                />
              </ArticleElementWrapper>
              {newDesign ? (
                <AdsContainer className="my-6 lg:my-8">{adsImu1}</AdsContainer>
              ) : (
                <>{adsImu1}</>
              )}
            </>
          )}
          {!newDesign &&
            (!showRegBanner || !showSubBanner || !showReg2Banner) &&
            adsImu1}
        </>
      );

    case 2:
      return newDesign ? (
        <AdsContainer className="mb-6 lg:mb-8">{adsImu1}</AdsContainer>
      ) : null;

    case 5:
      return newDesign ? (
        <AdsContainer className="mb-6 lg:mb-8">{adsMidArticle}</AdsContainer>
      ) : (
        <>{adsMidArticle}</>
      );

    case 6:
      if (contentAccess === LabelCardIconVariety.FREE && !newDesign) {
        return (
          <div className="max-w-[825px] mb-8">
            <ArticleCardCarousel
              renderedCount={3}
              renderItems={latestRegisteredArticle}
              className="mt-sm"
              referer={Referer.ARTICLE}
            />
          </div>
        );
      }
      return null;

    default:
      return null;
  }
}
